/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Benefit_Daily_Bonus_BoxInputs */

const en_benefit_daily_bonus_box = /** @type {(inputs: Benefit_Daily_Bonus_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily Bonus Cake Box`)
};

const ar_benefit_daily_bonus_box = /** @type {(inputs: Benefit_Daily_Bonus_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صندوق كعك المكافأة اليومية`)
};

const de_benefit_daily_bonus_box = /** @type {(inputs: Benefit_Daily_Bonus_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tägliche Bonus-Kuchenbox`)
};

const es_benefit_daily_bonus_box = /** @type {(inputs: Benefit_Daily_Bonus_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caja de pasteles de bonificación diaria`)
};

const fr_benefit_daily_bonus_box = /** @type {(inputs: Benefit_Daily_Bonus_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boîte à gâteaux bonus quotidienne`)
};

const it_benefit_daily_bonus_box = /** @type {(inputs: Benefit_Daily_Bonus_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scatola di torte bonus giornaliera`)
};

const ja_benefit_daily_bonus_box = /** @type {(inputs: Benefit_Daily_Bonus_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デイリーボーナスケーキボックス`)
};

const ko_benefit_daily_bonus_box = /** @type {(inputs: Benefit_Daily_Bonus_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일일 보너스 케이크 상자`)
};

const pt_br_benefit_daily_bonus_box = /** @type {(inputs: Benefit_Daily_Bonus_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caixa de bolo bônus diária`)
};

const ru_benefit_daily_bonus_box = /** @type {(inputs: Benefit_Daily_Bonus_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежедневная бонусная коробка с тортом`)
};

const th_benefit_daily_bonus_box = /** @type {(inputs: Benefit_Daily_Bonus_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กล่องเค้กโบนัสรายวัน`)
};

const tr_benefit_daily_bonus_box = /** @type {(inputs: Benefit_Daily_Bonus_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günlük Bonus Pasta Kutusu`)
};

const zh_cn_benefit_daily_bonus_box = /** @type {(inputs: Benefit_Daily_Bonus_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每日加码一个蛋糕盒`)
};

const zh_tw_benefit_daily_bonus_box = /** @type {(inputs: Benefit_Daily_Bonus_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每日加碼一個蛋糕盒`)
};

/**
* | output |
* | --- |
* | "Daily Bonus Cake Box" |
*
* @param {Benefit_Daily_Bonus_BoxInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const benefit_daily_bonus_box = /** @type {((inputs?: Benefit_Daily_Bonus_BoxInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Benefit_Daily_Bonus_BoxInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_benefit_daily_bonus_box(inputs)
	if (locale === "ar") return ar_benefit_daily_bonus_box(inputs)
	if (locale === "de") return de_benefit_daily_bonus_box(inputs)
	if (locale === "es") return es_benefit_daily_bonus_box(inputs)
	if (locale === "fr") return fr_benefit_daily_bonus_box(inputs)
	if (locale === "it") return it_benefit_daily_bonus_box(inputs)
	if (locale === "ja") return ja_benefit_daily_bonus_box(inputs)
	if (locale === "ko") return ko_benefit_daily_bonus_box(inputs)
	if (locale === "pt_br") return pt_br_benefit_daily_bonus_box(inputs)
	if (locale === "ru") return ru_benefit_daily_bonus_box(inputs)
	if (locale === "th") return th_benefit_daily_bonus_box(inputs)
	if (locale === "tr") return tr_benefit_daily_bonus_box(inputs)
	if (locale === "zh_cn") return zh_cn_benefit_daily_bonus_box(inputs)
	return zh_tw_benefit_daily_bonus_box(inputs)
});